import { getData } from "./apiService";

export const unsubscribeToEmail = async (email: string): Promise<boolean> => {
    try {
        const response = await getData(`/unsubscribe/email?email=${encodeURIComponent(email)}`);
        return response.success;
    } catch (error: any) {
        console.error('Failed to unsubscribe email.', error);
        return false;
    }
};